import axios from "../../axiosConfig/axios";

export default {
    getProfiles(callback,type,token,filter,companyProfiles = true){
        let url = 'admin/profiles'
        axios.get(url,{
            params: {
                type: type,
                companyProfiles: companyProfiles,
                filter: filter
            },
            headers: {Authorization: token}
        }).then(res=>{
            callback(null,res.data)
        }).catch(error=>{
            callback({
                message : error
            },null)
        })
    }
}